import { render, staticRenderFns } from "./e-wall.vue?vue&type=template&id=bfaa9cde&scoped=true&"
import script from "./e-wall.vue?vue&type=script&lang=ts&"
export * from "./e-wall.vue?vue&type=script&lang=ts&"
import style0 from "./e-wall.vue?vue&type=style&index=0&id=bfaa9cde&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfaa9cde",
  null
  
)

export default component.exports